import Vue from 'vue/dist/vue.esm';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [{
  path: '/',
  component: (resolve) => {
    import('./home.vue').then(resolve);
  },
}];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
});

export default router;